<template>
  <div class="fish-divider landing-wrapper">
    <img src="@/assets/images/Home/centered-fish.svg" alt="fish" />
  </div>
</template>

<script>
export default {
  name: 'FishDivider'
}
</script>

<style lang="scss" scoped>
@import './fish-divider';
</style>
